export default __webpack_public_path__ + "static/media/promoTag.54f09f25.svg";